import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import Styles from './BrandKitIntegrationsDrawer.module.scss'
import { DrawerProps } from 'components/Drawer/Root'
import { ChannelIcon } from 'components/ChannelIcon/ChannelIcon'
import { Service } from 'components/ArticlePostPreview/PostPreviewBody/IntegrationsDrawer/Service'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { Text } from 'blaze-ui/Text/Text'

export interface BrandKitIntegrationsDrawerProps extends DrawerProps {
  handleConnect: (platform: ExternalIntegrationEnum) => void
}

export const BrandKitIntegrationsDrawer = observer((props: BrandKitIntegrationsDrawerProps) => {
  const { closeAllDrawers } = useRootStore().drawersStore

  const onConnect = (platform: ExternalIntegrationEnum) => {
    closeAllDrawers()
    props.handleConnect(platform)
  }

  return (
    <div className={Styles.container}>
      <Text color="var(--dark-80)">
        Blaze will creating your Brand Kit from your social media content to match your unique style.
      </Text>
      <div className={Styles.services}>
        <Service
          onClick={() => onConnect(ExternalIntegrationEnum.Instagram)}
          icon={<ChannelIcon channel={ChannelType.InstagramPosts} />}
          label="Instagram"
        />
        <Service
          onClick={() => onConnect(ExternalIntegrationEnum.LinkedIn)}
          icon={<ChannelIcon channel={ChannelType.LinkedInPosts} />}
          label="LinkedIn"
        />

        <Service
          onClick={() => onConnect(ExternalIntegrationEnum.Facebook)}
          icon={<ChannelIcon channel={ChannelType.FacebookPost} />}
          label="Facebook"
        />
      </div>
    </div>
  )
})
